'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['utm_id', 'utm_content', 'utm_medium', 'utm_source', 'utm_campaign', 'utm_term'];
module.exports = exports['default'];